import { useContext } from 'react';
import { WebsiteEditorDialogContext } from './WebsiteEditorDialog.context';
import { ScopedDialogMethods } from '@shared/hooks/useDialogManager';

export const useWebsiteEditorDialogContext = (dialogId: string): ScopedDialogMethods => {
  const context = useContext(WebsiteEditorDialogContext);

  if (!context) {
    throw new Error('useWebsiteEditorDialogContext must be used within a WebsiteEditorDialogProvider');
  }

  return context.getScopedMethods(dialogId);
};
